import useAuthForm from '../useAuthForm';
import { UseAuthFormButtonLabelProps } from './props';
import { AuthStep } from '@/enums/auth/authStep';
import useTranslation from 'next-translate/useTranslation';
import { KycCheckpointId } from '@starsoft/common/enums';
import { useCurrentModal } from '@starsoft/common/hooks';
import { Either } from '@starsoft/common/interfaces';
import { ModalsKey } from '@/enums/modalsKey';

export function useAuthFormButtonLabel<T>({
  methods,
}: UseAuthFormButtonLabelProps<T>) {
  const { t } = useTranslation('login');
  const modal: Either<ModalsKey, undefined> = useCurrentModal(
    ModalsKey,
  ) as Either<ModalsKey, undefined>;

  const {
    step,
    kycMeByOriginIdQuery: { firstValidStep },
  } = useAuthForm({ methods });

  switch (step) {
    case AuthStep.Form:
      switch (modal) {
        case ModalsKey.Register:
          return t('register_label');
        case ModalsKey.Login:
          return t('submit_label');
        default:
          return t('submit_label');
      }
    case AuthStep.Kyc:
      switch (firstValidStep?.toString()) {
        case KycCheckpointId.AddressVerification?.toString():
          return t('common:address_verification_label');
        case KycCheckpointId.CriminalRecordCheck?.toString():
          return t('common:criminal_record_check_label');
        case KycCheckpointId.DocumentSubmission?.toString():
          return t('common:document_submission_label');
        case KycCheckpointId.Identity?.toString():
          return t('common:identity_label');
        case KycCheckpointId.VerifiedTaxId?.toString():
          return t('common:verified_tax_id_label');
        case KycCheckpointId.ProofOfResidence?.toString():
          return t('common:proof_of_residence_label');
        case KycCheckpointId.ProofOfIncome?.toString():
          return t('common:proof_of_income_label');
        case KycCheckpointId.VerifiedEmail?.toString():
          return t('common:verified_email_label');
        case KycCheckpointId.VerifiedPhoneNumber?.toString():
          return t('common:verified_phone_number_label');
        default:
          return t('submit_label');
      }
  }
}
